<template>
  <pt-detection-package-update class="pt-detection-package-update__withData"></pt-detection-package-update>
</template>

<script>
import PtDetectionPackageUpdate from './index'
export default {
  name: 'pt-detection-package-update__withData',
  components: {
    'pt-detection-package-update': PtDetectionPackageUpdate
  }
}
</script>
